// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__CKGJW","centeredMax":"Layout_centeredMax__IIZvI","inner":"Layout_inner__sB1dD"};